module.exports = __webpack_public_path__ + "img/arrowsOrange.6314f95d.png";